<template>
  <div>
    <slot name="activate" :open-dialog="openDialog" />

    <v-dialog v-model="dialog" width="800" persistent scrollable>
      <v-card class="py-6">
        <v-card-text>
          <section class="d-flex justify-center align-center gap-16 mt-5 mb-9">
            <v-avatar size="30" color="#FFF1E3">
              <v-icon size="30" color="#FB871C">mdi-information-outline</v-icon>
            </v-avatar>
            <span class="font-24 font-w-600 black--text">
              กรุณาตรวจสอบความถูกต้อง
            </span>
          </section>

          <section>
            <div
              v-if="productSelect.length === 0"
              class="text-center font-16 pt-6 pb-10"
            >
              <span>ไม่พบข้อมูล</span>
            </div>

            <div v-else>
              <section class="mb-4 text-right">
                <span class="font-14 font-w-500 black--text">
                  จำนวนรายการสินค้าที่มีการเก็บราคา :
                  {{ productSelect.length }} รายการ
                </span>
              </section>

              <section class="table--header">
                <div style="flex: 2">
                  <span>ชื่อสินค้า</span>
                </div>
                <div style="flex: 1">
                  <span>ราคาซื้อเข้า</span>
                </div>
                <div style="flex: 1">
                  <span>ราคาขายออก</span>
                </div>
                <div style="flex: 1">
                  <span>ปริมาณซื้อเข้า</span>
                  <br />
                  <span>/ เดือน</span>
                </div>
                <div style="flex: 1">
                  <span></span>
                </div>
              </section>

              <section
                v-for="(item, index) in productSelect"
                :key="index"
                class="table--body"
              >
                <div style="flex: 2" class="text-left">
                  <div class="px-4">
                    <span class="line-clamp-2">
                      {{ index + 1 }}. {{ item.name || '-' }}
                    </span>
                  </div>
                </div>
                <div style="flex: 1">
                  <span>
                    {{ numberFormat(item.wholesale_price) }}
                  </span>
                </div>
                <div style="flex: 1">
                  <span>{{ numberFormat(item.retail_price) }}</span>
                </div>
                <div style="flex: 1">
                  <span>{{ item.stock || '0' }}</span>
                </div>
                <div style="flex: 1">
                  <button @click="removeProduct(item.product_id)">
                    <v-avatar size="34" color="#F6E8EA">
                      <v-icon size="24" color="#A9182A">
                        mdi-trash-can-outline
                      </v-icon>
                    </v-avatar>
                  </button>
                </div>
              </section>
            </div>
          </section>
        </v-card-text>
        <v-card-actions class="justify-center gap-20">
          <button class="btn-red-outline" @click="dialog = false">
            กลับไปแก้ไขข้อมูล
          </button>
          <button
            class="btn-red"
            :disabled="productSelect.length === 0"
            @click="save"
          >
            บันทึกราคา
          </button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import numeral from 'numeral'

export default {
  props: {
    customerId: {
      type: String,
      default: '',
    },
    tableProductSelect: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      dialog: false,
      productSelect: [],
      ipAddress: null,
    }
  },
  methods: {
    numberFormat(value) {
      return numeral(value).format('0,0.00')
    },
    checkIP() {
      fetch('https://api.ipify.org?format=json')
        .then((response) => response.json())
        .then((data) => {
          this.ipAddress = data.ip
        })
    },
    openDialog() {
      this.productSelect = this.tableProductSelect.filter(
        (product) => product.status,
      )
      this.checkIP()
      this.dialog = true
    },
    removeProduct(productId) {
      this.productSelect = this.productSelect.filter(
        (product) => product.product_id !== productId,
      )
    },
    async save() {
      try {
        const data = {
          customer_id: this.customerId,
          ip_user: this.ipAddress,
          items: this.productSelect.map((product) => {
            const outPriceFlag =
              Number(product.middle_price_in) !== 0 &&
              (Number(product.wholesale_price) < Number(product.min_price_in) ||
                Number(product.wholesale_price) > Number(product.max_price_in))
                ? 'Y'
                : ''

            return {
              product_id: product.product_id,
              out_price_flag: outPriceFlag,
              wholesale_price: product.wholesale_price || '0',
              retail_price: product.retail_price || '0',
              stock: product.stock || '0',
            }
          }),
        }

        const res = await this.$axios.post(
          `${this.$baseAPI}/priceandstock/recive`,
          data,
          { headers: this.setheaders },
        )

        if (res.data.ret && res.data.ret.error == 0) {
          Swal.fire({
            icon: 'success',
            title: `บันทึกสำเร็จ`,
            showConfirmButton: false,
            timer: 1500,
          })

          this.$emit('saveEmit')
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: `บันทึกข้อมูลไม่สำเร็จ`,
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonColor: '#A9182A',
          confirmButtonText: 'ตกลง',
          timer: 1500,
        })
        console.log(error)
      } finally {
        this.dialog = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.table {
  &--header {
    display: flex;
    font-size: 14px;
    color: #fff;
    font-weight: 600;
    background-color: #505d6f;
    padding-block: 12px;
    text-align: center;
    border-radius: 8px;
    align-items: center;
  }
  &--body {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #2d2d2d;
    font-weight: 500;
    padding-block: 12px;
    margin-top: 12px;
    text-align: center;
    border-radius: 8px;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
  }
}

.btn-red-outline {
  width: 164px;
  height: 45px;
  border-radius: 8px;
  border: 1px solid #a9182a;
  background: #fff;
  box-shadow: 5px 5px 18px 0px rgba(0, 0, 0, 0.08);
  color: #a9182a;
}

.btn-red {
  width: 164px;
  height: 45px;
  border-radius: 8px;
  background: linear-gradient(270deg, #a9182a 0%, #d70a0a 100%);
  box-shadow: 5px 5px 18px 0px rgba(0, 0, 0, 0.08);
  color: #fff;
  &:disabled {
    background: #acacac;
    border: none;
  }
}
</style>
